const todayIso = () => {
  const now = new Date();
  const local = new Date(now.getTime() - now.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 10);
};

export const isPreorderActive = (book) =>
  Boolean(book?.isPreorder && book?.preorderReleaseDate && book.preorderReleaseDate >= todayIso());

export const formatReleaseDate = (value) => {
  if (!value) return '';
  return new Date(`${String(value).slice(0, 10)}T00:00:00`).toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
};
